import done from './img/done.svg'
import { ButtonBasic } from "@lk-gtcom/ecomlab-components";
import { ModalComponent } from '../ModalComponent/ModalComponent';
import './ModalSuccessful.scss'
import { TitlePage } from '../../TitlePage/TitlePage';
import { TextPage } from '../../TextPage/TextPage';

const ModalSuccessful = ({
    setIsModal,
    title = '',
    description = ''
}) => {

    return (
        <ModalComponent
            onClose={e => setIsModal(false)}
            title={'Уведомление'}
            style={{
                maxWidth: '500px',
                height: 'auto'
            }}
            child={
                <div className='modal-successful'>
                    {title && <TitlePage
                        medium
                        title={title}
                    />}

                    <img src={done} />

                    {description && <TextPage
                        text={description}
                    />}

                    <ButtonBasic
                        green
                        text='Ok'
                        onClick={(e) => setIsModal(false)}
                    />
                </div>
            }
        />
    )
}

export { ModalSuccessful }